import { render, staticRenderFns } from "./PageTICKETS.vue?vue&type=template&id=7be98e06"
import script from "./PageTICKETS.vue?vue&type=script&lang=js"
export * from "./PageTICKETS.vue?vue&type=script&lang=js"
import style0 from "./PageTICKETS.vue?vue&type=style&index=0&id=7be98e06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports